/**
 * exam-manager.js

 * 概述:
 * 考试管理服务API
 *
 * API:
  1.发起考试             createExam
  2.修改考试             editExam
  3.查询单一考试信息     queryExam(旧接口，后期要更换掉)
  4.查询考试的任务进度   queryExamMonitor
  5.删除考试             deleteExam
 * @author Qiutm 2018/4/28
 */
import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

const basePath = '/ExamServer'
const basePathNew = '/ExamService'
const candidatePath = '/CandidateServer'
const scanPath = '/scan'

const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

/**
 * 发起考试
 * @param  {object} data [考试信息]
 *  {
      examId: '',
      examName: '',
      examInfo: {
        examId: '',
        gradeId: '12',
        examProperty: ['', '', '12', 'mock-exam', ''],
        examName: '',
        orgId: '',
        chargeId: '',
        examDate: ['', ''],
        pjDate: '',
        publishDate: '',
        reportType: '0',
        importFlag: '0',
        school: [[["学校id1","学校名称1"，"学校id2","学校名称2"], [], []]
      },
      subject: [{"subjectId":"","subjectName":"","subjectCode":"","subjectvariety":"0","examType":"1","chargeId":"","chargeName":"","teachSubject":""}],
      importFlag: '0'
    }
 * @return {object} promise
 */
const createExam = (data) => {
  let urlParam = `${basePathNew}/setExamInfo`
  return axios.post(urlParam, data).then(res => res.data)
}

/**
 * 教育局任务分配接口
 * @author changh 2018-05-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const setExamTeacherEdu = (data) => {
  let urlParam = `${basePathNew}/setExamTeacherEdu`
  return axios.post(urlParam, data).then(res => res.data)
}

/**
 * 教育局任务分配查询接口
 * @author changh 2018-05-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const listExamAllotPjTask = (data) => {
  let urlParam = `${basePathNew}/listExamAllotPjTask`
  return axios.post(urlParam, data).then(res => res.data)
}

/**
 * 任务分配，按题分配，查询已经分配的老师或组长
 * @author changh 2018-05-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const listTeachersOrLeaders = (data) => {
  let urlParam = `${basePath}/examTeacher.jsp?flag=listTeachersOrLeaders`
  return axios.post(urlParam, data).then(res => res.data)
}

/**
 * 任务分配，缓存分配的老师或者组长，每次选老师或组长时调用
 * @author changh 2018-05-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const addTeacherTemporary = (data) => {
  let urlParam = `${basePathNew}/addTeacherTemporary`
  return axios.post(urlParam, data).then(res => res.data)
}

/**
 * 修改考试
 * @param  {object} data [考试信息]
 *  {
      examId: '',
      examName: '',
      examInfo: {
        examId: '',
        gradeId: '12',
        examProperty: ['', '', '12', 'mock-exam', ''],
        examName: '',
        orgId: '',
        chargeId: '',
        examDate: ['', ''],
        pjDate: '',
        publishDate: '',
        reportType: '0',
        importFlag: '0',
        school: [[["学校id1","学校名称1"，"学校id2","学校名称2"], [], []]
      },
      subject: [{"subjectId":"","subjectName":"","subjectCode":"","subjectvariety":"0","examType":"1","chargeId":"","chargeName":"","teachSubject":""}],
      importFlag: '0',
      checkCode: '',
      needCheckCode: true,
      mobilePhone: ''
    }
 * @return {object} promise
 */
const editExam = (data) => {
  return axios.post(`${basePathNew}/updateExamEdu`, data).then(res => res.data)
}

const editExamSchool = (data) => {
  return axios.post(basePathNew + '/updateExamSchool', data)
    .then(res => res.data)
}
/**
 * 查询单一考试
 * @param  {object} data [考试id信息]  { examId: '' }
 * @return {object} promise
 */
const queryExam = (data) => {
  let param = 'app=queryExam&flag=queryExam&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${basePath}/exammanage.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询单一考试
 * @param  {object} data [考试id信息]  {data: {examId: '' }}
 * @return {object} promise
 */
const queryExamInfo = (data) => {
  return axios.post(basePathNew + '/queryExam', data)
    .then(res => res.data)
}

/**
 * 查询考试进度
 * @param  {object} data [考试id信息]  { examId: '', subjectName: '可选'}
 * @return {object} promise
 */
const queryExamMonitor = (data) => {
  return axios.get(basePathNew + '/examMonitor', {params: data})
    .then(res => res.data)
}

/**
 * 查询考试扫描明细
 * @param  {object} data {"data":{"examId":"1572945882364","orgId":"1571125955196","subjects":[{"subjectId":"1571295433988"}]}
 * @return {object} promise
 */
const queryExamProcessAndMonitorInfo = (data) => {
  return axios.post(basePathNew + '/queryExamProcessAndMonitorInfo', data)
    .then(res => res.data)
}
/**
 * 删除考试
 * @param  {object} data {examId: '', checkCode: '', needCheckCode: true, mobilePhone: ''}
 * @return {object} promise
 */
const deleteExam = (data) => {
  let urlParam = `${basePathNew}/delExam`
  return axios.post(urlParam, data).then(res => res.data)
}

/**
 * 上传匹配老师(选老师时候)--单题
 * @author wangk 2018-05-07T16:00:09+0800
 * @param  {Object} params {
 *                           query: 'examId=1525256466061&subjectId=1523870605249&userId=1523870605301&dispatchType=1&schoolId=',
 *                           formData: [FormData Instance]
 *                         }
 * @return {Promise}
 */
const upLoadTeachers = (params = {}) => {
  return axios.post(`${basePathNew}/upLoadTeachers?${params.query}`, params.formData)
    .then(res => res.data)
}

/**
 * 上传匹配老师(选老师时候)--整个科目
 * @author wangk 2018-05-07T16:00:09+0800
 * @param  {Object} params {
 *                           query: 'examId={}&subjectId={}&userId={}',
 *                           formData: [FormData Instance]
 *                         }
 * @return {Promise}
 */
const matchTeachers = (params = {}) => {
  return axios.post(`${basePathNew}/matchTeachers?${params.query}`, params.formData)
    .then(res => res.data)
}

/**
 * 查询当前老师(组长)拥有哪些题的权限
 * @author wangk 2018-05-16T10:19:54+0800
 * @param  {Object} params { examId: '', subjectId: '', userId: '', roleCode: '7' }
 * @return {[type]}        roleId: 1, 2, 3 都返回 ['01-20', '111', '222']
 *                                 4, 5, 8 都返回 ['111', '222']
 *                                 7       都返回 ['111']
 */
const queryUserVisableDivs = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${basePath}/exammanage.jsp`, `app=queryUserVisableDivs&flag=queryUserVisableDivs&json=${json}`, axiosConfig)
    .then(res => res.data)
}
/**
 * 查询评卷任务
 * @author chenxb 2020-09-02T15:19:54+0800
 * @param {JSON} {"examId":"","subjectId":"", orgId:""}
 * @return {Promise}
 */
const queryDispatchTask = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${basePath}/dispatchTask.jsp`, `app=dispatchTask&flag=query&json=${json}`, axiosConfig)
    .then(res => res.data)
}
/**
 * 获取组长在一个考试理得题目关系
 * @author chenxb 2020-09-02T15:19:54+0800
 * @param  {Object} params json: {"teacherId":"1571295460398","examInfo":[{"examId":"1593331736687","subjects":[{"divIds":["26","27"],"subjectId":"1571125908425"}],"dispatchType":2}]}
 * @return {Promise}
 */
const queryLeaderItemRelation = (params = {}) => {
  let json = JSON.stringify(params)
  console.log(json)
  return axios.post(`${basePath}/exammanage.jsp`, `app=queryTempCharger&flag=query&json=${json}`, axiosConfig)
    .then(res => res.data)
}
/**
 * 获取一个老师在一个考试里的题目关系
 * @author chenxb 2020-09-02T15:19:54+0800
 * @param  {Object} params json: {"examId":"1593331736687","subjectId":"1571125908425","schoolId":"1571125955196","teacherId":"1571295460398"}
 * @return {Promise}
 */
const queryTeacherItemRelation = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${basePath}/exammanage.jsp`, `app=queryDivTeacher&flag=queryDivTeacher&json=${json}`, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询考试基本信息: 信息老师, 参考学校数量, 各科目工作人员、考生数量
 * @author wangk 2018-07-27T09:21:51+0800
 * @param  {Object} params {data: {
 *                           orgId: '123', // 当前用户所在机构的 orgId
 *                           examId: '123',
 *                           subjectId: '123', // 可缺省
 *                           role: '4' // 角色 ID
 *                         }}
 * @return {Promise}
 */
const queryExamBaseInfo = (params = {}) => {
  return axios.post(basePathNew + '/queryExamBaseInfo', params)
    .then(res => res.data)
}

/**
 * 查询考试学校
 * @author wangk 2018-07-27T14:21:55+0800
 * @param  {Object} params {
 *                           data: {
 *                             examId: '123',
 *                             subjectId: '123',
 *                             orgId: '123', // 当前用户所在机构的 orgId
 *                             keyword: '实验' // 搜索关键字(支持模糊搜索)
 *                           },
 *                           pageNum: 1,
 *                           pageSize: 10
 *                         }
 * @return {Promise}
 */
const queryExamSchools = (params = {}) => {
  return axios.post(basePathNew + '/queryExamSchools', params)
    .then(res => res.data)
}

/**
 * 查询考试指定学校下的所有班级
 * @author wangk 2018-07-30T11:03:40+0800
 * @param  {Object} params {
 *                           data: {
 *                              examId: '123',
 *                              subjectId: '123',
 *                              orgId: '123' // 当前用户所在机构的 orgId
 *                            },
 *                            pageNum: 1,
 *                            pageSize: 10
 *                         }
 * @return {Promise}
 */
const queryExamClasses = (params = {}) => {
  return axios.post(basePathNew + '/queryExamClasses', params)
    .then(res => res.data)
}

/**
 * 导出考试工作人员
 * @author wangk 2018-07-30T14:18:00+0800
 * @param  {Object} params {
 *                           data: {
 *                              examId: '123',
 *                              subjectIds: ['123'], // 如果为空, 则导出所有科目的老师
 *                              creatorOrgId: '123', // 发起该考试的考试机构的 orgId
 *                              orgId: '123' // 当前用户所在机构的 orgId
 *                           }
 *                         }
 * @return {[type]}        [description]
 */
const exportExamStaff = (params = {}) => {
  return axios.post(basePathNew + '/exportExamStaff', params)
    .then(res => res.data)
}

/**
 * 导入考生
 * @param {object} data {
 *                          "importType": "",     //importCandidate:导入考生 || addToCandidate:追加考生
 *                          "fileType": "",       //traditionalCandidate:传统导入 || LearningAndSelectionTest:选学科目导入
 *                          "file":"文件流",
 *                          "userId": "操作用户Id",
 *                          "orgId": "机构Id或者学校Id",
 *                          "orgId": "机构Id或者学校Id",
 *                          "schools": ["id", "name"],
 *                          "examId": "111",
 *                          "examName": "fdsdf"
 *                       }
 * @return promise
 */
const importCandidatesAsync = (data) => {
  let options = {flag: 'importCandidatesAsync', json: data.params}
  return axios({ method: 'POST', url: `${candidatePath}/candidate.jsp?flag=importCandidatesAsync&json=${encodeURIComponent(JSON.stringify(data.params))}`, data: data.file })
    .then(res => res.data)
}

/**
 * 导出考试考生
 * @author wangk 2018-07-30T14:19:37+0800
 * @param  {Object} params {
 *                           data: {
 *                              creatorOrgId: '123', // 考试发起机构的 orgId
 *                              loginOrgId: '123', // 当前登录用户所在机构的 orgId
 *                              // 参加考试的机构(学校)的 orgId, 当且仅当是教育局发起的考试时, 使用该参数
 *                              // 如果是学校发起的考试, 则使用 classIds 传入班级 ID
 *                              // 该参数值为空时, 导出所有考生
 *                              orgIds: ['123'],
 *                              // 参加考试的班级的 classId, 当且仅当是学校发起的考试时, 使用该参数
 *                              // 如果是教育局发起的考试, 则使用 orgIds 传入班级 ID
 *                              // 该参数值为空时, 导出所有考生
 *                              rooms: ['123'],
 *                              examId: '123',
 *                              subjectId: '123'
 *                            }
 *                         }
 * @return {[type]}        [description]
 */
const exportExamCandidate = (params = {}) => {
  return axios.post(basePathNew + '/exportExamCandidate', params)
    .then(res => res.data)
}

/**
 * 查询考试是否扫描过
 * @param {*} params {examId:"1532943130200"}
 * @returns promise
 */
const queryExamHasScan = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${scanPath}/modelinfo.jsp`, `flag=HasScan&json=${json}`, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询指定老师是哪些题的组长
 * @author wangk 2018-08-10T15:18:54+0800
 * @param  {Object} params {
 *                           data: {
 *                             examId: '123',
 *                             subjectId: '123',
 *                             userId: '123',
 *                             taskFlag: '0'
 *                           }
 *                         }
 * @return {[type]}        [description]
 */
const queryGroupLeaderDiv = (params = {}) => {
  return axios.post(basePathNew + '/queryGroupLeaderDiv', params)
    .then(res => res.data)
}

/**
 * 查询已上报的考试列表
 * @author wangk 2018-08-24T10:26:37+0800
 * @param  {Object} params {
 *                           data: {
 *                             orgId: '123', // 当前登录用户所在机构的 orgId
 *                             userId: '123', // 当前用户 userId
 *                             role: '3', // 当前用户角色 ID
 *                             beginDate: '2018-08-12',
 *                             endDate: '2018-08-22'
 *                           },
 *                           pageNum: 1,
 *                           pageSize: 10
 *                         }
 * @return {[type]}        [description]
 */
const queryScoredExamList = (params = {}) => {
  return axios.post(basePathNew + '/queryScoredExamList', params)
    .then(res => res.data)
}
/**
 * 查询考试列表 ，取消发布界面用到
 * @param {} params
 */
const queryExamListUnrelease = (params = {}) => {
  return axios.post(basePathNew + '/queryExamListUnrelease', params)
    .then(res => res.data)
}
/**
 * 判断是否已出精准报告 ，代理商账号监控界面用到
 * @param {} params
 */
const hasPersonalReportFinished = (params = {}) => {
  return axios.post(basePathNew + '/hasPersonalReportFinished', {data: params})
    .then(res => res.data)
}
/**
 * 查询取消发布界面下载报表考试机构列表 ，取消发布界面用到
 * @param {} params
 */
const queryExamOrgs = (params = {}) => {
  return axios.post(basePathNew + '/queryExamOrgs', params)
    .then(res => res.data)
}
/**
 * 选择学校生成报表 ，取消发布界面用到
 * @param {} params
 */
const generateReport = (params = {}) => {
  return axios.post(basePathNew + '/generateReport', params)
    .then(res => res.data)
}

/**
 * 查询考试科目上报详情
 * @param {object} params {data: {examId: ''}}
 */
const listSubjectExist = (params = {}) => {
  return axios.post(basePathNew + '/listSubjectExist', params)
    .then(res => res.data)
}

/**
 * 查询报表权限
 * @author wangk 2018-08-29T14:23:00+0800
 * @param  {Object} params { data: { examId: '' } }
 * @return {[type]}        [description]
 */
const queryExamReportVisibilities = (params = {}) => {
  return axios.post(basePathNew + '/queryExamReportVisibilities', params)
    .then(res => res.data)
}

/**
 * 保存报表权限
 * @author wangk 2018-08-29T14:23:58+0800
 * @param  {Object} params {
 *                           visibilities: [
 *                             { examId: '', roleId: '2', subOrgRole: 1, reportItem: 'singleSubject' }
 *                           ]
 *                         }
 *                         subOrgRole 为 1 表示是中间机构的信息管理员
 * @return {[type]}        [description]
 */
const saveExamReportVisibilities = (params = {}) => {
  return axios.post(basePathNew + '/saveExamReportVisibilities', params)
    .then(res => res.data)
}

/**
 * 查询各科目出成绩状态(是否可以下载成绩)
 * @author wangk 2018-08-30T09:46:20+0800
 * @param  {Object} params {
 *                           data: {
 *                             orgId: '123',
 *                             examId: '123',
 *                             userId: '123',
 *                             role: '4'
 *                           }
 *                         }
 * @return {[type]}        [description]
 */
const querySubjectScoreStatus = (params = {}) => {
  return axios.post(basePathNew + '/querySubjectScoreStatus', params)
    .then(res => res.data)
}

/**
 * 查询考试科目
 * @author wangk 2018-10-23T09:47:42+0800
 * @param  {Object} params { data: { examId: '', userId: '' } }
 * @return {[type]}        [description]
 */
const queryExamSubjects = (params = {}) => {
  return axios.post(basePathNew + '/queryExamSubjects', params)
    .then(res => res.data)
}

/**
 * 查询考试主客观题设置情况 -1: 未设置; 0: 有主观和客观; 1: 只有客观; 2: 只有主观
 * @param {*} params {examId:"1532943130200"}
 * @returns promise
 */
const querySubjectZgAndKg = (params = {}) => {
  return axios.post(basePathNew + '/querySubjectItemAbsentConfig', params)
    .then(res => res.data)
}
/**
 * 查询科目任务分配类型
 * @author changh 2017-05-12T15:43:08+0800
 * @param  {[type]}   param    {"data":{"examId":"1572945882364"}}
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
const queryExamSubjectDispatchType = (params = {}) => {
  return axios.post(basePathNew + '/listExamSubjectDispatchType', params)
    .then(res => res.data)
}
/**
 * 查询考试任务非配类型，分区，分校，随机，评卷模式，按题，全卷
 * @author changh 2020-09-02T15:03:38+0800
 * @param  {[type]} param {data: {examId: "1593331736687", subjectId: "1571125908425"}}
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
const queryDispatchInfo = (params = {}) => {
  return axios.post(basePathNew + '/queryDispatchInfo', params)
    .then(res => res.data)
}

/**
 * 查询机构/学校考试列表
 * @author changh 2020-11-10T15:03:38+0800
 * @param  {[type]} param {"data":{"orgId":"1597716772806","status":[1,2]},"pageNum":1,"pageSize":1000}
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
const queryExamList = (params = {}) => {
  return axios.post(basePathNew + '/queryExamList', params)
    .then(res => res.data)
}

/**
 * 查询评卷教师，组长可以有权限的考试列表
 * @author changh 2020-11-10T15:03:38+0800
 * @param  {[type]} param {"data":{"orgId":"1597716772806","userId":"1597719506086","examStatus":[1,2]}}
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
const queryUserVisableExamSubjectInfo = (params = {}) => {
  return axios.post(basePathNew + '/queryUserVisableExamSubjectInfo', params)
    .then(res => res.data)
}

/**
 * 根据考试ID，获取考试中的学校，包含学校的准考证号情况
 * @author changh 2020-11-10T15:03:38+0800
 * @param  {[type]} param {"data":{"examId":"1597716772806"}}
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
const querySchoolZkzhLength = (params = {}) => {
  return axios.post(basePathNew + '/querySchoolZkzhLength', params)
    .then(res => res.data)
}

/**
 * 查询精准报告
 * @author chenxb 2020-12-01T09:47:42+0800
 * @param  {Object} params { data: { examId: '', orgName: '', status: '', } }
 * @return {[type]}        [description]
 */
const queryPersonalReportAuth = (params = {}) => {
  return axios.post(basePathNew + '/queryPersonalReportAuth', params)
    .then(res => res.data)
}
/**
 * 下载精准报告
 * @author chenxb 2020-12-02T09:47:42+0800
 * @param  {Object} params { data: { examId: '', schoolId: '', } }
 * @return {[type]}        [description]
 */
const queryPersonalReportUrl = (params = {}) => {
  return axios.post(basePathNew + '/queryPersonalReportUrl', params)
    .then(res => res.data)
}
/**
 * 设置查看权限
 * @author chenxb 2020-12-01T09:47:42+0800
 * @param  {Object} params { data: { examId: '', auth: true, orgId: '', } }
 * @return {[type]}        [description]
 */
const setPersonalReportViewAuth = (params = {}) => {
  return axios.post(basePathNew + '/setPersonalReportViewAuth', params)
    .then(res => res.data)
}
/**
 * 设置下载权限
 * @author chenxb 2020-12-01T09:47:42+0800
 * @param  {Object} params { data: { examId: '', auth: true, orgId: '', } }
 * @return {[type]}        [description]
 */
const setPersonalReportDownAuth = (params = {}) => {
  return axios.post(basePathNew + '/setPersonalReportDownAuth', params)
    .then(res => res.data)
}

/**
 * 查询红框定位信息
 * @author changh 2020-12-01T09:47:42+0800
 * @param  {Object} params {"data":{"examId":"1593136425487","subjectId":"1571295412252","divId":"271"}}
 * @return {[type]}        [description]
 */
const queryRedFrameDivCords = (params = {}) => {
  return axios.post(basePathNew + '/queryRedFrameDivCords', params)
    .then(res => res.data)
}
/**
 * 获取参考班级（校级导入流程）
 * @author changh 2020-12-01T09:47:42+0800
 * @param  {Object} params {"data":{"examId":"1593136425487"}}
 * @return {[type]}        [description]
 */
const listExamClass = (params = {}) => {
  return axios.post(basePathNew + '/listExamClass', params)
    .then(res => res.data)
}
/**
 * 删除考生数据
 * @author chenxb 2024-05-15T10:47:42+0800
 * @param  {Object} params {"data":{"examId":"1593136425487", "subjectId":"1593136425487", "studentIdList":"1593136425487,123123"}}
 * @return {[type]}        [description]
 */
const delStudent = (data) => {
  return axios.post(`${candidatePath}/deleteStudents`, data)
    .then(res => res.data)
}
/**
 * 删除考生扫描数据
 * @author chenxb 2024-05-15T10:47:42+0800
 * @param  {Object} params {"data":{"examId":"1593136425487", "subjectId":"1593136425487", "studentIdList":"1593136425487,123123"}}
 * @return {[type]}        [description]
 */
const delStudentScan = (data) => {
  return axios.post(`scan/deleteStudent`, data)
    .then(res => res.data)
}

export {
  createExam,
  setExamTeacherEdu,
  listExamAllotPjTask,
  listTeachersOrLeaders,
  addTeacherTemporary,
  queryExam,
  queryExamInfo,
  editExam,
  editExamSchool,
  queryExamMonitor,
  queryExamProcessAndMonitorInfo,
  deleteExam,
  upLoadTeachers,
  matchTeachers,
  queryUserVisableDivs,
  queryDispatchTask,
  queryLeaderItemRelation,
  queryTeacherItemRelation,
  queryExamBaseInfo,
  queryExamSchools,
  queryExamClasses,
  exportExamStaff,
  exportExamCandidate,
  importCandidatesAsync,
  queryExamHasScan,
  queryGroupLeaderDiv,
  queryScoredExamList,
  listSubjectExist,
  queryExamReportVisibilities,
  saveExamReportVisibilities,
  querySubjectScoreStatus,
  queryExamSubjects,
  querySubjectZgAndKg,
  queryExamSubjectDispatchType,
  queryExamListUnrelease,
  hasPersonalReportFinished,
  queryExamOrgs,
  generateReport,
  queryDispatchInfo,
  queryExamList,
  queryUserVisableExamSubjectInfo,
  queryPersonalReportAuth,
  queryPersonalReportUrl,
  setPersonalReportViewAuth,
  setPersonalReportDownAuth,
  queryRedFrameDivCords,
  querySchoolZkzhLength,
  listExamClass,
  delStudent,
  delStudentScan
}



// WEBPACK FOOTER //
// ./src/model/exam-manager-model.js